module.exports = __webpack_public_path__ + "public/media/ic_new_logo_color_white.25d49eb2.svg";